import { InputHTMLAttributes, forwardRef } from 'react';

import { InputStyled, LabelStyled } from './Toggle.styled';

type TogglePropsT = InputHTMLAttributes<HTMLInputElement> & {
  name: string;
};

const Toggle = forwardRef<HTMLInputElement, TogglePropsT>(({ name, ...restProps }, ref) => (
  <>
    <InputStyled id={name} name={name} type="checkbox" ref={ref} {...restProps} />
    <LabelStyled htmlFor={name} />
  </>
));

export default Toggle;
